$(document).ready(function() {
	if( $('.wrapper').hasClass('brand') ) {
		if( $('.team-intro_slider').length > 0 ) {
			var spaceBetween = 10;
			var slidewidth = 64;
			if( $(window).width() < 1024 ) {
				spaceBetween = 5;
			}
			var maxTireImgPerView = $('.team-intro_slider .swiper-container.thumbs .swiper-slide').length;
			$('.team-intro_slider .swiper-container.thumbs').css('width', maxTireImgPerView * (slidewidth + spaceBetween) - spaceBetween);
		

			var team_intro_thumbs = new Swiper('.team-intro_slider .swiper-container.thumbs', {
				spaceBetween: 5,
				slidesPerView: maxTireImgPerView,
				loop: false,
				loopedSlides: 10, //looped slides should be the same
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				breakpoints: {
					1024: {
						spaceBetween: 10
					}
				}

			});

			var team_intro_slider = new Swiper('.team-intro_slider .swiper-container.top', {
				loop:false,
				loopedSlides: 10, //looped slides should be the same
				pagination: {
					el: '.team-intro_slider .swiper-pagination-custom',
					type: 'fraction',
				},
				scrollbar: {
					el: '.team-intro_slider .swiper-scrollbar-custom',
					hide: false,
					dragSize:'auto',
					draggable:true
				},
				navigation: {
					nextEl: '.team-intro_slider .swiper-button-next',
					prevEl: '.team-intro_slider .swiper-button-prev',
				},
				thumbs: { swiper: team_intro_thumbs }
			});

			$('.team-intro_slider').data('swiper', team_intro_slider);

			$(window).on('resize',function() {
				slidewidth = 64;
				if( $(window).width() < 1024 ) {
					spaceBetween = 5;
				}else{
					spaceBetween = 10;
				}
				var _size  =  maxTireImgPerView * (slidewidth + spaceBetween) - spaceBetween;
				$('.team-intro_slider .swiper-container.thumbs').css({ width:_size });
			}).trigger('resize');

		}
	}
});